import { type CountryPhoneData, countryPhoneData } from "./countryPhoneData";

export const getCountryMask = (countryCode: string) => {
  const country = countryPhoneData.find(
    (c: CountryPhoneData) => c.code === countryCode,
  );
  if (!country) throw Error("Не удалось получить маску для номера");

  return country.mask;
};

export const createPatternFromMask = (mask: string) => {
  const regexStr = mask
    .replace(/9/g, "\\d")
    .replace(/\(/g, "\\(")
    .replace(/\)/g, "\\)")
    .replace(/\+/g, "\\+")
    .replace(/-/g, "\\-")
    .replace(/\s/g, "\\s")
    .replace(/#/g, "\\d");

  return new RegExp(`^${regexStr}$`);
};
